"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableType = void 0;
var VariableType;
(function (VariableType) {
    VariableType["string"] = "string";
    VariableType["number"] = "number";
    VariableType["boolean"] = "boolean";
})(VariableType = exports.VariableType || (exports.VariableType = {}));
//# sourceMappingURL=validateVariables.js.map